import { cfg } from "../../configuracion";
import { md5 } from "../md5";

export const updateResidenteCorregido = async (idioma, json, token) => {
    let respuesta = {
        datos: null,
        error: null
    };
    try {
        const url = `${cfg.apiUrl}/residentecorregido`;

        const resp = await fetch(url, {
            method: 'PUT',
            headers: {
                'Accept-Language': idioma,
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,

                // Deshabilitar provisionalmente la caché
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0"
            },
            body: JSON.stringify(json)
        });

        if (resp.ok) {
            let datos = await resp.json();
            respuesta = { ...respuesta, datos };
        } else {
            let errorMessage = `Error: ${resp.status}`;
            try {
                const errorData = await resp.json();
                if (errorData.mensaje) {
                    errorMessage = errorData.mensaje;
                }
            } catch (e) {
                console.error("Error parsing error response", e);
            }
            respuesta = { ...respuesta, error: errorMessage };
        }
    } catch (error) {
        respuesta = { ...respuesta, error: error.message };
    }
    return respuesta;
};
